export function getView(patient_image) {
  return !!patient_image ? 'PatientImage' : 'ImagePlaceholder'
}
